import React, {useEffect, useRef, useState} from "react";
import starImg from "./img/star.png";
import {ReactComponent as Info} from "./img/info.svg";
import styles from "./preferences-rating.module.css";
import texts from "../../assets/ContextProvider/textsLocalized.json"


const PreferencesRating = ({selectedPreferences, setSelectedPreferences}) => {
  const buttonTypes = [
    {rating: "0 - 4", context: "0 - 4", imgPath: starImg},
    {rating: "4.1 - 7", context: "4.1 - 7", imgPath: starImg},
    {rating: "7.1 - 10", context: "7.1 - 10", imgPath: starImg},
  ];
  const [isPopupShown, setIsPopupShown] = useState(false);
  const timerInfoPopup = useRef(null);
  const infoPopupRef = useRef(null);


  const handleChangeRating = (e) => {
    const selectedRating = e.currentTarget.dataset.preferencesRating;
    const isSelected = selectedPreferences.ratingIMDb === selectedRating;
    let updatedRating;

    if (isSelected) {
      updatedRating = "";
    } else {
      updatedRating = selectedRating;
    }

    setSelectedPreferences(prev => ({
      ...prev,
      ratingIMDb: updatedRating
    }))
  };


  const handleShowExplanation = () => {
    setIsPopupShown(true);
  }


  useEffect(() => {
    timerInfoPopup.current = setTimeout(() => {
      setIsPopupShown(false);
    }, 3500);

    return () => {
      clearTimeout(timerInfoPopup.current);
    }
  }, [isPopupShown]);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (infoPopupRef.current && !infoPopupRef.current.contains(e.target)) {
        setIsPopupShown(false);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside);
    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, []);


  return (
    <>
      <div className={styles["preferences-rating-title"]}>
        {texts.preferences["rating-title"]}
        <div className={styles["preferences-rating-info-container"]}>
          <Info className={styles["preferences-rating-info"]}
                onClick={handleShowExplanation}/>
          <div ref={infoPopupRef}
               className={
                 `${styles["preferences-rating-info-popup"]}
                  ${isPopupShown ? `${styles["info-popup-show"]}` : ""}`}>
            <span className={styles["info-popup-description"]}>
              {texts.preferences["rating-info-popup"]}
            </span>
          </div>
        </div>
      </div>
      <div className={styles["preferences-rating-container"]}>
        <div className={styles["preferences-rating-btn-container"]}>
          {buttonTypes.map((item, index) => (
            <button
              key={index}
              className={
                `${styles["preferences-rating-btn"]}
                   ${selectedPreferences.ratingIMDb === item.rating ?
                  `${styles["active"]} ${styles["preferences-rating-btn-selected"]}` : ""}`}
              onClick={handleChangeRating}
              data-preferences-rating={item.rating}>
              {item.context}
              <img className={styles["preferences-rating-img"]}
                   src={item.imgPath}
                   alt="emoji"/>
            </button>
          ))}
        </div>
      </div>
    </>
  )
}

export default PreferencesRating;